import Swiper from 'swiper/bundle'

window.customElements.define('single-product-call-out', class extends HTMLElement {
    connectedCallback() {
        const container = this.querySelector('.swiper-container')
        if (!container) return

        const config = {
            slidesPerView: 1,
            watchOverflow: true,

            pagination: {
                el: this.querySelector('[data-swiper-pagination]'),
                clickable: true
            },

            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
        }

        this.swiper = new Swiper(container, config)
    }

    disconnectedCallback() {
        this.swiper?.destroy(true, true)
        this.swiper = null
    }

})